

















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class KSlider extends Vue {
  @Prop() value!: number;
  @Prop() min!: number;
  @Prop() max!: number;
  @Prop() label!: string;
  @Prop({ default: undefined }) preview!: (value: number) => {};
}
